import { render } from "./BaseSelect.vue?vue&type=template&id=1fb59d9a&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=1fb59d9a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1fb59d9a"

export default script